import { useState } from "react";
import { CloseIcon } from "@/components/atoms/Icons";

export default function HeaderBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;

  return (
    <div
      className={`w-100 fx-v fx--ch bc-blue-light banner-strip ${
        isVisible ? "show" : ""
      }`}
    >
      <span className="tc-black text--md">
        <strong>Forbes</strong> Best Answering Service 2026
      </span>
      <span className="close-btn-wrapper ps-a">
        <CloseIcon
          width="16"
          height="16"
          color="#33393D"
          className="icon close-icon"
          onClick={() => setIsVisible(false)}
          data-testid="close-icon"
        />
      </span>
      <style jsx>{`
        .banner-strip {
          position: fixed;
          max-height: 48px;
          z-index: 99;
          padding: 11px 0;
        }
        .close-btn-wrapper {
          right: 50px;
          font-size: 0;
        }
        @media screen and (max-width: 768px) {
          .banner-strip {
            padding: 11px 0 11px 20px;
            justify-content: left;
          }
          .close-btn-wrapper {
            right: 15px;
          }
        }
      `}</style>
    </div>
  );
}
